export default __webpack_public_path__ + "static/media/bci-7.bc069e26.svg";